import { createSlice } from '@reduxjs/toolkit'

export const langSlice = createSlice({
  name: 'lang',
  initialState: {
    value: localStorage.getItem('lang') || 'en_GB',
  },
  reducers: {
    changeLang: (state, action) => {
      state.value = action.payload
    },
  },
})

export const { changeLang } = langSlice.actions

export const getLang = (state) => {
  return state.lang.value
}

export default langSlice.reducer
